/**
 * Task extension properties
 */ export var TaskExtensionProperties;
(function(TaskExtensionProperties) {
    TaskExtensionProperties["copilot"] = "copilot";
})(TaskExtensionProperties || (TaskExtensionProperties = {}));
